import {
    FIRMWARE_REQUESTS_DETAILS_OPEN_MODAL,
    FIRMWARE_REQUESTS_DETAILS_REQUEST,
    FIRMWARE_REQUESTS_DETAILS_RESULT
} from 'Redux/actionTypes';

export const firmwareRequestDetailsOpenModal = (open, data) => ({
    type: FIRMWARE_REQUESTS_DETAILS_OPEN_MODAL,
    payload: { open, data }
})

export const firmwareRequestDetailsRequest = (data) => ({
    type: FIRMWARE_REQUESTS_DETAILS_REQUEST,
    payload: { data }
})

export const firmwareRequestDetailsResult = (data) => ({
    type: FIRMWARE_REQUESTS_DETAILS_RESULT,
    payload: { data }
})